import { createLoadableList } from 'external/immutability-helper'

import { clearedChangedPackageAlias, clearedSelectUser, clearedUserState, PackageState } from 'types/context/package'

import create, {initializeAndRegisterHooks} from 'context/create' 
import triggers, * as resolves from './triggers'

const id = 'Package'

export const initialState: PackageState = {
    packages: createLoadableList(),
    packageRefreshes: 0,
    packageItem: {
        loading: false,
        courses: {
            basic: [],
            elective: []
        },
        data: null
    },
    modals: {
        changePackageAlias: clearedChangedPackageAlias,
        selectStudent: clearedSelectUser,
        selectTutor: clearedSelectUser,
        addTutor: clearedUserState,
        addStudent: clearedUserState,
        studentAssignmentWarning: {open: false}
    },
    saving: {}
}



const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, triggers, resolves)})
export {context as default}